import React from 'react';
import { Hero } from './components/Hero';
import { BenefitsBar } from './components/BenefitsBar';
import { ImageCarousel } from './components/ImageCarousel';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ExpertSection } from './components/ExpertSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCloseSection } from './components/FinalCloseSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-coral selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <BenefitsBar data-id="element-2" />
      <ImageCarousel data-id="element-3" />
      <PainSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <ContentSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <ExpertSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCloseSection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}